import React, { useEffect, useState } from "react";
import {
   handleChangedRelatedField,
   handleGridTechname,
   renderDevInfo,
   handleFieldAlert,
} from "../../GeneralScripts";
import { useDebouncedCallback } from "use-debounce";
import { Form } from "antd";
import { useIntl } from "react-intl";
import { DatePicker } from "../../../BP2Components";
import { useFormContext } from "../../../../context/FormContext/FormContext";
import moment from "moment";
import "./CalendarField.less";
import { Icon_Clock } from "../../../BP2Components/Icons/icons";
import FieldInfo from "../FieldInfo/FieldInfo";
import { getAllFieldsWithAlerts, handleTemplateAlert } from "../../../../util/Scripts";

const CalendarField = ({
   isRequired,
   element,
   form,
   isVisible,
   disabled,
   formId,
   insideGrid = false,
   initialValue,
   rowDataId,
   setChangelogData,
}) => {
   const intl = useIntl();
   const { getFieldDecorator } = form;
   const {
      formData,
      changeFieldPendingStatus,
      fieldsInfo,
      setFieldsInfo,
      fieldOptions,
      fieldEnumMap,
   } = useFormContext();
   const [infoText, setInfoText] = useState(null);
   const allFieldsWithAlerts = getAllFieldsWithAlerts(formData?.forms_data?.tab?.[0]?.elements);

   const handleDateChange = useDebouncedCallback(() => {
      if (isVisible(element)) {
         const time =
            element.enum === "time"
               ? moment(form.getFieldValue(element.tech_name)).format("HH:mm:ss")
               : moment(form.getFieldValue(element.tech_name)).format("YYYY-MM-DD");
         setChangelogData && setChangelogData(element.tech_name, time, element.label);
      }

      handleChangedRelatedField(
         element,
         form,
         setFieldsInfo,
         allFieldsWithAlerts,
         formId,
         intl,
         formData._formKey,
         rowDataId,
         changeFieldPendingStatus,
         fieldEnumMap,
      );

      element.hasAlert &&
         handleFieldAlert(
            element.id,
            element.tech_name,
            form,
            formData._formKey,
            setFieldsInfo,
            fieldEnumMap,
         );
   }, 1000);

   const translatedLabel = element.label;

   const infoClass =
      fieldsInfo[element.tech_name] && fieldsInfo[element.tech_name] !== ""
         ? "calendar-field-info"
         : "";

   useEffect(() => {
      const initVal = initialValue
         ? element.enum === "time"
            ? moment(initialValue, "HH:mm:ss").format("HH:mm:ss")
            : moment(initialValue).format("YYYY-MM-DD")
         : element.value &&
           (element.enum === "time"
              ? moment(element.value, "HH:mm:ss").format("HH:mm:ss")
              : moment(element.value).format("YYYY-MM-DD"));
      if (initVal !== "Invalid date") {
         setChangelogData && setChangelogData(element.tech_name, initVal);
      }
   }, []);

   const changeFieldValue = (value) => {
      form.setFieldsValue({ [element.tech_name]: value });
   };

   useEffect(() => {
      const infoText = fieldsInfo[element.tech_name];
      setInfoText(infoText);
      handleTemplateAlert(element.tech_name, infoText);
   }, [fieldsInfo[element.tech_name]]);

   useEffect(() => {
      if (!fieldOptions[element.tech_name]) return;
      const newValue = fieldOptions[element.tech_name][0]?.label;
      changeFieldValue(newValue);
      if (isVisible(element) && setChangelogData) {
         setChangelogData(element.tech_name, newValue);
      }
   }, [JSON.stringify(fieldOptions)]);

   return (
      <>
         <Form.Item
            label={!insideGrid && translatedLabel}
            className={`${element?.type}-field _type_${element?.type}_type_ _id_${element.id}_id_`}
            style={{
               display: isVisible(element) ? "" : "none",
               gridArea: handleGridTechname(element.tech_name),
            }}
            key={element.tech_name}
         >
            <>
               {getFieldDecorator(element.tech_name, {
                  rules: [
                     {
                        required: isRequired(element),
                        message: intl.formatMessage({ id: "field.required" }),
                     },
                  ],
                  initialValue: initialValue
                     ? element.enum === "time"
                        ? moment(initialValue, "HH:mm:ss")
                        : moment(initialValue)
                     : element.value &&
                       (element.enum === "time"
                          ? moment(element.value, "HH:mm:ss")
                          : moment(element.value)),
               })(
                  element.enum === "date" ? (
                     <DatePicker
                        className={`field_${element.tech_name} _type_${element?.type}_type_ _id_${element.id}_id_ ${infoClass} has-alert-${element.hasAlert}`}
                        disabled={disabled}
                        format="yyyy-MM-dd"
                        onChange={handleDateChange}
                     />
                  ) : element.enum === "date_time" ? (
                     <DatePicker
                        showTime
                        className={`field_${element.tech_name} _type_${element?.type}_type_ _id_${element.id}_id_ ${infoClass} has-alert-${element.hasAlert}`}
                        disabled={disabled}
                        format="yyyy-MM-dd HH:mm:ss"
                        onChange={handleDateChange}
                     />
                  ) : (
                     <DatePicker
                        showTime={true}
                        showTimeOnly={true}
                        timeIntervals={5}
                        format="HH:mm"
                        className={`field_${element.tech_name} _type_${element?.type}_type_ _id_${element.id}_id_ ${infoClass} has-alert-${element.hasAlert}`}
                        disabled={disabled}
                        onChange={handleDateChange}
                        icon={<Icon_Clock fill="#CBD5E1" />}
                     />
                  ),
               )}
            </>
            {renderDevInfo(element)}
            <FieldInfo text={infoText} />
         </Form.Item>
      </>
   );
};
export default CalendarField;
